import { CompanyLogoCircle } from '@/components/company-logo-circle';
import { cn } from '@/lib/utils';
import type { Company } from '@mss_creator/shared';
import { useState } from 'react';

export interface CompanyAvatarProps {
  company: Pick<Company, 'name' | 'logo' | 'noyau'>;
  className?: string;
}

const NOYAU_BG_CLASSES: Record<Company['noyau'], string> = {
  GSP: 'bg-rose',
  GPS: 'bg-rouge',
  PGS: 'bg-jaune',
  PSG: 'bg-vert',
  SPG: 'bg-bleu-ciel',
  SGP: 'bg-bleu-nuit',
};

/**
 * The company's round mark: its logo, framed the way it was saved (issue #20),
 * or the colour disc of its noyau when it has none — or when the image cannot
 * be loaded. Shared by the grid card and the archived card so that the way a
 * logo is drawn changes in one place.
 */
export function CompanyAvatar({ company, className }: CompanyAvatarProps) {
  const [brokenSrc, setBrokenSrc] = useState<string | null>(null);

  if (company.logo && brokenSrc !== company.logo.src) {
    const { src } = company.logo;
    return (
      <CompanyLogoCircle
        logo={company.logo}
        alt={company.name}
        {...(className ? { className } : {})}
        onError={() => setBrokenSrc(src)}
      />
    );
  }
  return (
    <div
      className={cn('h-16 w-16 rounded-full', NOYAU_BG_CLASSES[company.noyau], className)}
      aria-hidden="true"
    />
  );
}
